import createIcon from '../../createIcon';

/**
 * @component @name PhotoLibrary
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIgMTZWNEMyMiAyLjkgMjEuMSAyIDIwIDJIOEM2LjkgMiA2IDIuOSA2IDRWMTZDNiAxNy4xIDYuOSAxOCA4IDE4SDIwQzIxLjEgMTggMjIgMTcuMSAyMiAxNlpNMTEgMTJMMTMuMDMgMTQuNzFMMTYgMTFMMjAgMTZIOEwxMSAxMlpNMiA2VjIwQzIgMjEuMSAyLjkgMjIgNCAyMkgxOFYyMEg0VjZIMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PhotoLibrary = createIcon('PhotoLibrary', [
  [
    'path',
    {
      d: 'M22 16V4C22 2.9 21.1 2 20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16ZM11 12L13.03 14.71L16 11L20 16H8L11 12ZM2 6V20C2 21.1 2.9 22 4 22H18V20H4V6H2Z',
      key: 'i9jhp2',
    },
  ],
]);

export default PhotoLibrary;
